import { render, staticRenderFns } from "./fbtextdayhourbox.vue?vue&type=template&id=3b9f56e0&"
import script from "./fbtextdayhourbox.vue?vue&type=script&lang=js&"
export * from "./fbtextdayhourbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports